// export const base_url = "http://localhost:5600/api";
export const base_url = "https://stagedev.legacyx.uk/api";
// export const base_url = "http://localhost:4400/api";
// export const base_url = "http://localhost:5600/api";
